import React, { useCallback, useState, useEffect, useMemo } from "react";
import { Icon } from "../../CreateIcons";
import { useDispatch, useSelector } from "react-redux";
import SendInvitationDialog from "./SendInvitationDialog";
import HostNameDialog from "./HostNameDialog";
import ChooseTemplateDialog from "./ChooseTemplateDialog";
import { ShowDialogForPayment } from "./showdialogforpayment";

import ServiceButtons from '../../../redesign/components/ServiceButtons';

import {
  setEventServiceData,
  clearEventServiceData,
} from "../../../store/eventServiceSlice";
import {
  setEventDetails,
  clearAllEventDetails,
} from "../../../store/eventsliceforcart";
import { isProviderAddedForEventTabs } from "../../../store/cartSlice";
import {
  addToCart,
  removeFromCart,
  removePreistByEventId,
  clearPreistCart,
  clearTenthouseCart,
  clearCateringCart,
  makeGetEventServiceIdentifiers,
} from "../../../store/cartSlice";

import { addServiceToCart, clearEntireCart } from "../../../store/cartbodydataslice";
import { selectIdentifiersByEventId } from "../../../store/cartbodydataslice";
import { fetchTentCartAPI, fetchCateringCartAPI } from "../../../Apiservices/Auth/cart/Addtocart_api";
import { TabView, TabPanel } from "primereact/tabview";
import Alert from "@mui/material/Alert";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import "../EventTabs/EventTabs.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { loadEventImages } from "../../RSVPInvitationPage/invitationpageid";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import formatDate from "../../../util/FormateDate";
import EventForm from "../EventForm2";
import ThurentEventForm from "../../../redesign/components/ThurentEventForm";
import { Tooltip } from "primereact/tooltip";
import { useNavigate, useLocation } from "react-router-dom";
import claender from "../../../assets/images/calendar.png";
import locationicon from "../../../assets/images/location.png";
import {
  fetchinvitationtemplates,
  getinvitation_templates_by_category,
  fetchInvitationTemplateWithPng
} from "../../../Apiservices/Auth/servers/fetchinvitationtemplates";
import {
  CREATION_FORM,
  EDIT_FORM,
  getFormTypeData,
  getIsFirstVisit,
  setFormType,
} from "../../../services/AuthServices";
import { useLoginCartHandler } from "./useLoginCartHandler";
import { RSVPInvitationPage_pooja } from "../../RSVPInvitationPage/poojainvitationpage/RsvpInvitationpage_pooja";
import {
  fetchEvent,
  deleteEvent,
} from "../../../Apiservices/Auth/servers/fetchEvents";
import { fetchProviderData } from "../../../Apiservices/Auth/servers/fetchProviderData";
import config from "../../../config";
import {
  createEvent,
  updateEvent,
} from "../../../Apiservices/Auth/servers/createEvents";
import CreateUpdateEventDialog from "../../CreateUpdateEventDialog/CreateUpdateEventDialog";
import { useTentCart } from "../../../hooks/useTentCart";
import { usePriestCart } from "../../../hooks/usePriestCart";
import { useCateringCart } from "../../../hooks/usecateringcart";
import providerData from "../../../ProviderServices.json";
import { Mycustombutton } from "../../MyCustomButton/Mycustombutton";
import useMyOrders from "../../myorder/useMyOrders";

const EventTabs = () => {
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState({ upcoming: [], past: [], cancel: [] });
  const [dialogVisible, setDialogVisible] = useState(false);
  const [isUpdate, setIsUpdate] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const screensize = window.innerWidth;
  const navigate = useNavigate();
  const [eventIdToDelete, setEventIdToDelete] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [refundItems, setrefundItems] = useState([]);
  const [showCreateButton, setShowCreateButton] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [groupedUpcomingEvents, setGroupedUpcomingEvents] = useState({});
  const [groupedPastEvents, setGroupedPastEvents] = useState({});
  const [groupedCancelEvents, setGroupedCancelEvents] = useState({});
  const [refreshOrdersFlag, setRefreshOrdersFlag] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [processingCart, setProcessingCart] = useState(false);
  const [localEventCreated, setLocalEventCreated] = useState(false);

  const dispatch = useDispatch();
  const { selectedProviders, serviceType, shouldProcessCartAfterLogin } = useSelector(state => state.serviceBooking);
  const { eventCreated, processing, error } = useLoginCartHandler();
  const { removePriestCartItem } = usePriestCart();
  const { removeTentProvider, editbutton } = useTentCart();
  const { refreshCateringCart, removeCateringProvider } = useCateringCart();
  const { refreshMyOrders } = useMyOrders();

  // ✅ FIX 1: Move clearAllEventDetails to useEffect
  useEffect(() => {
    dispatch(clearAllEventDetails());
  }, [dispatch]);

  // Check provider list on mount
  useEffect(() => {
    const providerListStorageKey = config.providerListStorageKey;
    const providerList = localStorage.getItem(providerListStorageKey);
    if (providerList) {
      const info = JSON.parse(providerList);
      if (info.serviceDetails?.id !== 2) {
        navigate("/providers", { state: info });
        window.scrollTo({ top: 0 });
      }
    }
  }, [navigate]);

  const handleDeleteConfirm = (eventId) => {
    setEventIdToDelete(eventId);
    setShowDeleteDialog(true);
  };

  const deleteEventHandle = async (eventId) => {
    setLoading(true);
    try {
      const response = await deleteEvent(eventId);

      if (response?.status === 200) {
        setEvents(prevEvents => ({
          upcoming: prevEvents.upcoming.filter(event => event.id !== eventId),
          past: prevEvents.past.filter(event => event.id !== eventId),
          cancel: prevEvents.cancel.filter(event => event.id !== eventId)
        }));
        const itemsToRefund = response.data.refundedItems;
        const uniqueItemsToRefund = Object.values(
          response.data.refundedItems.reduce((acc, item) => {
            if (!acc[item.type]) {
              acc[item.type] = { ...item };
            }
            return acc;
          }, {})
        );

        if (uniqueItemsToRefund.length > 0) {
          setrefundItems(uniqueItemsToRefund);
          setShowDialog(true);
        }
      } else {
        console.error("Failed to delete event", response);
      }
    } catch (error) {
      console.error("Failed to services:", error);
    } finally {
      setLoading(false);
      window.scrollTo({ top: 0 });
    }
  };

  const handleCloseDialog = useCallback(() => {
    setDialogVisible(false);
    setSelectedEvent(null);
  }, []);

  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      const { upcomingEvents, pastEvents, cancelledEvents } = await fetchEvent();
      const formatted = formatEvents(upcomingEvents);
      setEvents({
        upcoming: formatted,
        past: formatEvents(pastEvents),
        cancel: formatEvents(cancelledEvents),
      });
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // Handle event creation success
  useEffect(() => {
    if (eventCreated) {
      setLocalEventCreated(true);
      setTimeout(() => setLocalEventCreated(false), 3000);
    }
  }, [eventCreated]);

  useEffect(() => {
    if (eventCreated && !processing) {
      const timer = setTimeout(() => {
        fetchEvents();
        setLocalEventCreated(true);
        setTimeout(() => setLocalEventCreated(false), 3000);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [eventCreated, processing, fetchEvents, shouldProcessCartAfterLogin]);

  useEffect(() => {
    const checkForCartProcessing = async () => {
      const hasProcessedFlag = localStorage.getItem('shouldProcessCartAfterLogin');
      const hasPendingData = localStorage.getItem('pendingCartData');

      if (!hasProcessedFlag && !hasPendingData && selectedProviders.length === 0) {
        setTimeout(() => {
          fetchEvents();
        }, 1000);
      }
    };

    checkForCartProcessing();
    if (selectedProviders.length === 0) {
      checkForCartProcessing();
    }
  }, [selectedProviders.length, fetchEvents]);

  const handleSubmitEvent = useCallback(async ({ eventDetails }) => {
    handleCloseDialog();
    setLoading(true);
    try {
      if (isUpdate) {
        await updateEvent(eventDetails, eventDetails.id);
      } else {
        const response = await createEvent(eventDetails);
        if (response && response.event && response.event.id) {
          await fetchEvents();
        }
      }
    } catch (error) {
      console.log("Something Went Wrong while Creating/updating Event ");
      console.log(error);
    } finally {
      await fetchEvents();
      setLoading(false);
    }
    handleCloseDialog();
  }, [isUpdate, fetchEvents, handleCloseDialog]);

  const openCreateEventDialog = useCallback(() => {
    setIsUpdate(false);
    setSelectedEvent(null);
    setDialogVisible(true);
  }, []);

  const openUpdateEventDialog = useCallback((event) => {
    setIsUpdate(true);
    setSelectedEvent(event);
    setDialogVisible(true);
  }, []);

  const EventTemplate = React.memo((props) => {
    const { onDeleteClick, ...event } = props;
    const [isInvitedByExists, setIsInvitedByExists] = useState(!!event?.invitedBy?.trim());
    const [haschoosentemplate, sethaschoosentemplate] = useState(!!event?.imagePath?.trim());
    const eventimageid = event?.EventMasterDetails?.image?.id || null;
    const [imageloading, setimageloading] = useState(false);
    const [hostName, setHostName] = useState("");
    const [inviteDialogVisible, setInviteDialogVisible] = useState(false);
    const [selectedpnimage, setselectedpnimage] = useState("");
    const [eventCategoryId, seteventCategoryId] = useState(null);
    const [invitedByInputDialogVisible, setInvitedByInputDialogVisible] = useState(false);
    const [chooselabelforinvitation, setchooselabelforinvitation] = useState(false);
    const [chooseTemplateLoading, setChooseTemplateLoading] = useState(false);
    const [EventDataForInvitation, setEventDataForInvitation] = useState({});
    const [eventcategoryname, seteventcategoryname] = useState("");
    const [EventCategories, setEventCategories] = useState([]);
    const [imageFromEventPath, setImageFromEventPath] = useState(null);
    const [eventimages, seteventimages] = useState([]);
    const shareToken = event.shareToken;
    const [serviceidforconstraint, setserviceidforconstraint] = useState(null);
    const [constraintMessage, setConstraintMessage] = useState("");
    const [ShowRemoveButton, setShowRemoveButton] = useState(true);
    const [eventIDForConstraint, setEventIDForConstraint] = useState(null);
    const [serviceconstraint, setserviceconstraint] = useState(false);
    const [selectedtemplate, setselectedtemplate] = useState();
    const [imagetemplateslength, setimagetemplateslength] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [copySuccess, setCopySuccess] = useState(false);
    const [selected_templateerror, setselected_templateerror] = useState("");
    const [eventUpdated, setEventUpdated] = useState(false);

    const location = useLocation();
    const eventID = event.id;

    useEffect(() => {
      dispatch(setEventDetails({
        eventID,
        eventDetails: event
      }));
    }, [dispatch, eventID, event]);

    const cartData = useSelector((state) => state.cartbodyslice.cart);
    const cateringAdded = useSelector((state) => isProviderAddedForEventTabs(state, eventID, 9));
    const rentalsAdded = useSelector((state) => isProviderAddedForEventTabs(state, eventID, 8));
    const priestAdded = useSelector((state) => isProviderAddedForEventTabs(state, eventID, 7));

    const typeToIconId = {
      Catering: 9,
      Rentals: 8,
      Priest: 7,
    };

    const selectIdentifiers = useMemo(makeGetEventServiceIdentifiers, []);
    const identifiers = useSelector(state => selectIdentifiers(state, eventID));

    // ✅ FIX 3: Memoize serviceAddedMap
    const serviceAddedMap = useMemo(() => ({
      Catering: cateringAdded,
      Rentals: rentalsAdded,
      Priest: priestAdded
    }), [cateringAdded, rentalsAdded, priestAdded]);

    const handleEventService = useCallback((service, isAdded) => {
      setserviceidforconstraint(service.type);
      setEventIDForConstraint(eventID);

      if (isAdded) {
        let message = "";
        let showRemove = false;
        const eventCart = cartData[eventID];

        if (!eventCart || Object.keys(eventCart).length === 0) {
          message = "You have already paid for this service. Check MyOrders.";
          showRemove = false;
        } else {
          message = "You have already added this service. Click remove if you want to add a new vendor.";
          showRemove = true;
        }

        setConstraintMessage(message);
        setShowRemoveButton(showRemove);
        setserviceconstraint(true);
        return;
      }

      if (event && Object.keys(event).length > 0) {
        const info = {
          serviceDetails: service,
          eventDetails: event,
        };

        dispatch(clearEventServiceData());
        dispatch(setEventServiceData(info));
        navigate("/providers", { state: info });
        window.scrollTo({ top: 0 });
      }
    }, [cartData, dispatch, navigate, eventID, event]);

    const handleRemoveService = useCallback((eventID) => {
      const serviceType = typeToIconId[serviceidforconstraint];
      if (!serviceType) return;

      if (Number(serviceType) === 7) {
        removePriestCartItem(identifiers.priestCartId, eventID);
        dispatch(removeFromCart({
          serviceType: 'preist',
          eventID,
          providerID: identifiers.priestProviderId,
        }));
      }

      if (Number(serviceType) === 8) {
        removeTentProvider(eventID, identifiers.tenthouseProviderId);
        dispatch(removeFromCart({
          serviceType: 'tenthouse',
          eventID,
          providerID: identifiers.tenthouseProviderId,
        }));
      }

      if (Number(serviceType) === 9) {
        identifiers.catering.forEach(item => {
          removeCateringProvider(eventID, item.providerId, item.mappingId);
          dispatch(removeFromCart({
            serviceType: 'catering',
            eventID,
            providerID: item.providerId,
            mapping_id: item.mappingId,
          }));
        });
      }
      setserviceconstraint(false);
    }, [serviceidforconstraint, identifiers, removePriestCartItem, removeTentProvider, removeCateringProvider, dispatch]);

    const editEventHandle = useCallback(() => {
      if (event && Object.keys(event).length > 0) {
        openUpdateEventDialog(event);
      }
    }, [event, openUpdateEventDialog]);

    const handleDeleteClick = useCallback(() => {
      onDeleteClick(event.id);
    }, [onDeleteClick, event.id]);

    const toggleMenu = useCallback(() => {
      setMenuOpen((prev) => !prev);
    }, []);

    const handleClick = useCallback(() => {
      if (shareToken && shareToken.length > 0)
        navigate("/dashboard/event/guests", { state: { shareToken } });
    }, [shareToken, navigate]);

    const callsomefunction = useCallback(async (selectedImagePath) => {
      setimageloading(true);

      const data = {
        eventName: event.eventTitle || "",
        eventCategoryName: event.EventMasterDetails?.eventCategoryName || "",
        eventType: event.eventTitle || "",
        eventTitle: event.eventTitle || "",
        invitedBy: hostName || event?.invitedBy || "",
        description: event.description || "",
        startDate: event.Date || "",
        startTime: event.startTime || "",
        endDate: event.endDate || "",
        endTime: event.endTime || "",
        city: event.city || "",
        area: event.area || "",
        state: event.state || "",
        venue: event.Location || "",
        locationLat: event.locationLat || "",
        locationLong: event.locationLong || "",
        caste: event.caste || null,
        religion: event.religion || null,
        language: event.language || null,
        region: event.region || null,
      };

      setEventDataForInvitation(data);

      try {
        const category_name = data.eventCategoryName;
        const screenType = screensize > 800 ? "web" : "mobile";

        let fetch_api_image = null;
        try {
          const cleanEventTitle = event.eventTitle.replace(/\//g, "or").replace(/ /g, "");
          fetch_api_image = await fetchinvitationtemplates(
            category_name,
            cleanEventTitle,
            screenType
          );
        } catch (err) {
          console.warn("Error fetching templates:", err);
          fetch_api_image = null;
        }

        const imagetrial = await load_all_category_images(fetch_api_image?.images || []);
        
        if (selectedImagePath) {
          seteventimages(imagetrial);
          setimagetemplateslength(fetch_api_image?.totalImages || 0);
          const matchedImage = imagetrial.find(img => img.name === selectedImagePath);
          setImageFromEventPath(matchedImage?.url || imagetrial[0]?.url || null);
        } else {
          seteventimages(imagetrial);
          setimagetemplateslength(fetch_api_image?.totalImages || 0);
          const matchedImage = imagetrial.find(img => img.name === event.imagePath);
          setImageFromEventPath(matchedImage?.url || imagetrial[0]?.url || null);
        }
      } catch (error) {
        console.warn("Unexpected error in image fetching:", error);
      } finally {
        setimageloading(false);
      }
    }, [event, hostName, screensize]);

    const load_all_category_images = useCallback(async (imagesMeta) => {
      const imageResults = [];
      try {
        for (const img of imagesMeta) {
          const fullUrl = `/templates-bg/${img.url}`;
          const blob = await getinvitation_templates_by_category(fullUrl);
          if (blob) {
            const blobUrl = URL.createObjectURL(blob);
            imageResults.push({ name: img.name, url: blobUrl });
          }
        }
      } catch (error) {
        console.warn("Error loading category images:", error);
      }
      return imageResults;
    }, []);

    const handleHostNameSubmit = useCallback(async (hostName, eventId) => {
      try {
        const eventData = { invitedBy: hostName };
        const success = await updateEvent(eventData, eventId);
        setEventUpdated(true);
        if (success) {
          setIsInvitedByExists(true);
          setInvitedByInputDialogVisible(false);
          callsomefunction();
        } else {
          console.error("Failed to update event.");
        }
      } catch (error) {
        console.error("An error occurred while saving the host name", error);
        setInvitedByInputDialogVisible(false);
      }
    }, [callsomefunction]);

    const handletemplatesubmit = useCallback(async (templateName) => {
      try {
        const eventData = { imagePath: templateName };
        const success = await updateEvent(eventData, event.id);
        setselectedpnimage(templateName);

        if (success) {
          sethaschoosentemplate(true);
          setchooselabelforinvitation(false);
          setInviteDialogVisible(true);
          callsomefunction(templateName);
        } else {
          console.error("Failed to update event.");
        }
      } catch (error) {
        console.error("An error occurred while saving the host name", error);
        setchooselabelforinvitation(false);
      }
    }, [event.id, callsomefunction]);

    const toggleShareOptions = useCallback(() => {
      if (isInvitedByExists) {
        if (!haschoosentemplate) {
          setChooseTemplateLoading(true);
          callsomefunction();
          setChooseTemplateLoading(false);
          setchooselabelforinvitation(true);
        } else if (haschoosentemplate) {
          callsomefunction();
          setInviteDialogVisible(true);
        }
      } else if (haschoosentemplate) {
        callsomefunction();
        setInviteDialogVisible(true);
      } else {
        setInvitedByInputDialogVisible(true);
      }
    }, [isInvitedByExists, haschoosentemplate, callsomefunction]);

    const hideDialog = useCallback(() => {
      setInviteDialogVisible(false);
    }, []);

    const shareUrl = `${config.INVITATION_URL}/${shareToken}`;
    const shareTitle = `Check out this event: ${event.eventTitle}`;
    const whatsappMessage = encodeURIComponent(`Check out this event: ${shareUrl}`);

    const handleCopy = useCallback(() => {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl)
          .then(() => {
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
          })
          .catch((err) => {
            console.error("Clipboard API failed, trying fallback...", err);
            fallbackCopyTextToClipboard(shareUrl);
          });
      } else {
        fallbackCopyTextToClipboard(shareUrl);
      }
    }, [shareUrl]);

    const fallbackCopyTextToClipboard = useCallback((text) => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand("copy");
        if (successful) {
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 2000);
        } else {
          console.error("Fallback copy failed.");
        }
      } catch (err) {
        console.error("Fallback: Unable to copy", err);
      }

      document.body.removeChild(textArea);
    }, []);

    const handleShare = useCallback((platform) => {
      const fullUrl = `${shareUrl}?token=${shareToken}`;
      let url = "";

      switch (platform) {
        case "whatsapp":
          url = `https://api.whatsapp.com/send?text=${whatsappMessage}`;
          break;
        case "facebook":
          url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`;
          break;
        case "twitter":
          url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(fullUrl)}&text=${encodeURIComponent(shareTitle)}`;
          break;
        case "gmail":
          const subject = encodeURIComponent("Invitation to " + event.eventTitle);
          const body = encodeURIComponent(`Hi,\n\nI would like to invite you to this event:\n\n${shareUrl}\n\nBest Regards.`);
          url = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${subject}&body=${body}`;
          break;
        default:
          console.log("Invalid platform");
          return;
      }

      window.open(url, "_blank");
    }, [shareUrl, shareToken, whatsappMessage, shareTitle, event.eventTitle]);

    const handlePrev = useCallback(() => {
      setCurrentIndex((prev) => (prev - 1 + eventimages.length) % eventimages.length);
    }, [eventimages.length]);

    const handleNext = useCallback(() => {
      setCurrentIndex((prev) => (prev + 1) % eventimages.length);
    }, [eventimages.length]);

    // ✅ FIX 4: Fix the onServiceSelect callback
    const handleServiceSelect = useCallback((type) => {
      const typeToCheck = type === "catering" ? "Catering" : 
                         type === "tent" ? "Rentals" : 
                         type === "priest" ? "Priest" : null;
      
      if (!typeToCheck) return;

      setserviceidforconstraint(typeToCheck);

      const serviceObj = providerData.find(
        (item) => item.type === typeToCheck
      );

      if (!serviceObj) return;

      handleEventService(serviceObj, serviceAddedMap[typeToCheck]);
    }, [handleEventService, serviceAddedMap]);

    return (
      <>
        <div className="card-item">
          <div className="event-card">
            <div className="event-date-box">
              {eventimageid ? (
                <div>
                  <img src={`${config.API_BASE_URL}/gallery/download/${eventimageid}`}
                    className="eventimages_display" alt="event" />
                </div>
              ) : (
                <div className="calendar-display">
                  <div className="calendar-month">
                    {new Date(event.Date).toLocaleString("default", {
                      month: "short",
                      timeZone: "UTC",
                    })}
                  </div>
                  <div className="calendar-day">
                    {new Date(event.Date).getDate()}
                  </div>
                </div>
              )}
            </div>

            <div className="event-content">
              <div className="event-header">
                <h3 className="event-title">
                  {event.eventTitle || "Untitled Event"}
                </h3>
                {event.cancel === true && (
                  <>
                    <div className="Cancled-Box">
                      <span className="cancled-text">Cancelled</span>
                    </div>
                  </>
                )}
                {!event.past && !event.cancel && (
                  <div className="event-options-container" style={{ position: 'relative' }}>
                    <div
                      className="event-options"
                      onClick={toggleMenu}
                      aria-label="Event options"
                    >
                      <span role="button">⋮</span>
                    </div>

                    <div className={`event-menu ${menuOpen ? "open" : ""}`}>
                      <button
                        className="menu-item edit-button"
                        onClick={editEventHandle}
                        aria-label="Edit event"
                      >
                        <i className="pi pi-pen-to-square" style={{ marginRight: "8px" }}></i>
                        EDIT
                      </button>
                      <button
                        className="menu-item delete-button"
                        onClick={handleDeleteClick}
                        aria-label="Delete event"
                      >
                        <i className="pi pi-times" style={{ marginRight: "8px" }}></i>
                        DELETE
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="event-meta">
                <div className="event-datetime">
                  <span className="meta-icon">
                    <img src={claender} alt="calendar" style={{ width: "16px", height: "16px" }} />
                  </span>
                  {new Date(event.Date).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    timeZone: "UTC",
                  })} {" "}
                  {new Date(event.Date).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                    timeZone: "UTC",
                  })}
                </div>

                <div className="event-location">
                  <span className="meta-icon">
                    <img src={locationicon} alt="location" style={{ width: "18px", height: "18px" }} />
                  </span>
                  {event.Location || "Location not specified add location"}
                </div>
              </div>
            </div>
          </div>

          <div className="analysiscontainer">
            {!event.past && !event.cancel && (
              <div className="event-actions">
                <ServiceButtons
                  showPriest={event.EventMasterDetails?.isPriestRequired === true}
                  showCatering={true}
                  showTent={true}
                  isLoggedIn={true}
                  onServiceSelect={handleServiceSelect}
                />

                <div className="service_actionsbuttons" onClick={toggleShareOptions}>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13.2216 8.93538L4.21245 13.6764C3.3958 14.1063 2.43645 13.4009 2.65115 12.5287L3.75969 8.0269L2.65115 3.5239C2.43645 2.65166 3.3958 1.94687 4.21245 2.37674L13.2216 7.11778C13.9675 7.5108 13.9675 8.54236 13.2216 8.93538Z"
                        stroke={"#646464"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9.34087 8.01172L3.78516 8.03988"
                        stroke={"#646464"}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <Mycustombutton
                    label="Send Invitation"
                    onClick={toggleShareOptions}
                  />
                </div>
              </div>
            )}
          </div>

          {event.rsvpCounts && (
            <div style={{ gap: "6px" }} className="event-actions rsvp-summary">
              <div className="rsvp-info">
                {!event.past ? (
                  <>
                    <span>Invited: <span style={{ color: "red" }}>{event.rsvpCounts.totalCount}</span> </span>
                    <span>Attending: <span style={{ color: "red" }}>{event.rsvpCounts.comingCount}</span> </span>
                    <span>Not Attending: <span style={{ color: "red" }}>{event.rsvpCounts.notComingCount}</span></span>
                  </>
                ) : (
                  <>
                    <span>Invited: <span style={{ color: "red" }}>{event.rsvpCounts.totalCount}</span> </span>
                    <span>Attended: <span style={{ color: "red" }}>{event.rsvpCounts.comingCount}</span> </span>
                    <span>Not Attended: <span style={{ color: "red" }}>{event.rsvpCounts.notComingCount}</span></span>
                  </>
                )}
              </div>
              {!event.cancel && (
                <div>
                  <button
                    className="menu-item view-response-button"
                    onClick={handleClick}
                    aria-label="View guest responses"
                  >
                    <i className="pi pi-list" style={{ fontSize: '14px' }}></i>
                    VIEW LIST
                  </button>
                </div>
              )}
            </div>
          )}
          <hr className="event-divider" />
        </div>

        <Dialog
          visible={serviceconstraint}
          header="Service Already Added"
          modal
          onHide={() => setserviceconstraint(false)}
          footer={
            ShowRemoveButton ? (
              <div>
                <button
                  className="button_for_constraint"
                  onClick={() => setserviceconstraint(false)}
                >
                  Close
                </button>
                <button
                  className="button_for_constraint"
                  onClick={() => handleRemoveService(eventIDForConstraint)}
                >
                  Remove
                </button>
              </div>
            ) : (
              <div>
                <button
                  className="button_for_constraint"
                  onClick={() => setserviceconstraint(false)}
                >
                  Close
                </button>
                <button className="myordersnavigation" onClick={() => navigate(`/myorder?eventId=${event.id}`)}>
                  myorders
                </button>
              </div>
            )
          }
        >
          {constraintMessage}
        </Dialog>

        <SendInvitationDialog
          visible={inviteDialogVisible}
          onHide={hideDialog}
          shareUrl={shareUrl}
          shareTitle={shareTitle}
          whatsappMessage={whatsappMessage}
          image={imageFromEventPath}
          imageloading={imageloading}
          EventDataForInvitation={EventDataForInvitation}
        />

        <ChooseTemplateDialog
          visible={chooselabelforinvitation}
          onHide={() => setchooselabelforinvitation(false)}
          selectedTemplate={selectedtemplate}
          setSelectedTemplate={setselectedtemplate}
          selectedTemplateError={selected_templateerror}
          handleTemplateSubmit={handletemplatesubmit}
          imageloading={imageloading}
          eventimages={eventimages}
          currentIndex={currentIndex}
          handlePrev={handlePrev}
          handleNext={handleNext}
          imagetemplateslength={imagetemplateslength}
          EventDataForInvitation={EventDataForInvitation}
          loadingOverlay={chooseTemplateLoading}
        />

        <HostNameDialog
          visible={invitedByInputDialogVisible}
          onHide={() => setInvitedByInputDialogVisible(false)}
          hostName={hostName}
          setHostName={setHostName}
          onSubmit={() => {
            handleHostNameSubmit(hostName, event.id);
            setInvitedByInputDialogVisible(false);
            setchooselabelforinvitation(true);
          }}
        />
      </>
    );
  });

  const handleFormType = useCallback(() => {
    const { formType, formId } = getFormTypeData();
    setFormType(null);
    if (formType === CREATION_FORM) {
      openCreateEventDialog();
    } else if (formType === EDIT_FORM) {
      const existedEvent = events.upcoming.find((event) => event.id === formId);
      if (existedEvent && Object.keys(existedEvent).length > 0) {
        openUpdateEventDialog(existedEvent);
      }
    } else {
      console.log("No valid form type set");
    }
  }, [events.upcoming, openCreateEventDialog, openUpdateEventDialog]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  useEffect(() => {
    if (!loading) {
      handleFormType();
    }
  }, [loading, handleFormType]);

  const formatEvents = useCallback((events) => {
    return events.map(({
      id,
      status,
      eventTitle,
      eventType,
      eventId,
      EventMasterDetails,
      startDate,
      description,
      venue,
      shareToken,
      rsvpCounts,
      startTime,
      endDate,
      endTime,
      locationLat,
      locationLong,
      area,
      city,
      state,
      invitedBy,
      imagePath,
    }) => ({
      id,
      status,
      eventTitle: eventTitle || eventType,
      EventMasterDetails: EventMasterDetails,
      eventId: eventId,
      Date: startDate,
      desc: description,
      Location: venue,
      shareToken,
      rsvpCounts,
      startTime,
      endDate,
      endTime,
      locationLat,
      locationLong,
      area,
      city,
      state,
      invitedBy,
      imagePath,
    }));
  }, []);

  // Add past and cancel flags
  const upcomingEventsWithFlags = useMemo(() => {
    return events.upcoming;
  }, [events.upcoming]);

  const pastEventsWithFlags = useMemo(() => {
    return events.past.map(event => ({ ...event, past: true }));
  }, [events.past]);

  const cancelEventsWithFlags = useMemo(() => {
    return events.cancel.map(event => ({ ...event, cancel: true }));
  }, [events.cancel]);

  const upcomingEventCount = useCallback(() => {
    return (
      <span className="custom-tab-header">
        Your Upcoming Events{" "}
        <span className="badge">
          {events.upcoming.length > 0 ? events.upcoming.length : "0"}
        </span>
      </span>
    );
  }, [events.upcoming.length]);

  const pastEventCount = useCallback(() => {
    return (
      <span className="custom-tab-header">
        Your Past Events{" "}
        <span className="badge">
          {events.past.length > 0 ? events.past.length : "0"}
        </span>
      </span>
    );
  }, [events.past.length]);

  const cancelEventCount = useCallback(() => {
    return (
      <span className="custom-tab-header">
        Cancelled Events{" "}
        <span className="badge">
          {events.cancel.length > 0 ? events.cancel.length : "0"}
        </span>
      </span>
    );
  }, [events.cancel.length]);

  const groupEventsByMonth = useCallback((eventsArray) => {
    return eventsArray.reduce((groups, event) => {
      const eventMonthYear = new Date(event.Date).toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      });

      if (!groups[eventMonthYear]) {
        groups[eventMonthYear] = [];
      }
      groups[eventMonthYear].push(event);
      return groups;
    }, {});
  }, []);

  useEffect(() => {
    setGroupedUpcomingEvents(groupEventsByMonth(upcomingEventsWithFlags));
    setGroupedPastEvents(groupEventsByMonth(pastEventsWithFlags));
    setGroupedCancelEvents(groupEventsByMonth(cancelEventsWithFlags));
  }, [upcomingEventsWithFlags, pastEventsWithFlags, cancelEventsWithFlags, groupEventsByMonth]);

  // ✅ FIX 6: Fix the showCreateButton logic
  useEffect(() => {
    const shouldShow = 
      (dialogVisible === false) &&
      (isUpdate === true ||
        (Array.isArray(events.upcoming) && events.upcoming.length === 0)) &&
      (!serviceType || serviceType.trim() === "");

    setShowCreateButton(shouldShow);
  }, [isUpdate, events.upcoming, serviceType, dialogVisible]);

  return (
    <div className="display-container">
      <div className="display-containerbox">
        <div className="display-containerbox_left">
          <TabView style={{ width: "100%", maxWidth: "650px" }}>
            <TabPanel style={{ width: "100%", color: "black" }} header={upcomingEventCount()}>
              <div className="events-container" style={{ width: "100%" }}>
                {loading ? (
                  <h3 style={{ textAlign: "center" }}>
                    <i className="pi pi-spin pi-spinner-dotted" style={{ fontSize: "2rem", color: "#0cc0df" }}></i>
                  </h3>
                ) : events.upcoming.length > 0 ? (
                  <div className="events-list">
                    {Object.keys(groupedUpcomingEvents)
                      .sort((a, b) => new Date(b) - new Date(a))
                      .map((monthYear, index) => (
                        <div key={index}>
                          <div className="event-header">
                            <span className="event-date">
                              <h3>{monthYear}</h3>
                            </span>
                          </div>
                          {groupedUpcomingEvents[monthYear]
                            .sort((a, b) => (a.id > b.id ? -1 : 1))
                            .map((event, idx) => (
                              <EventTemplate
                                key={event.id}
                                {...event}
                                onDeleteClick={handleDeleteConfirm}
                              />
                            ))}
                        </div>
                      ))}
                  </div>
                ) : (
                  <h3 style={{ textAlign: "center" }}>No Upcoming Events found.</h3>
                )}
              </div>
            </TabPanel>

            <TabPanel style={{ width: "100%", color: "black" }} header={pastEventCount()}>
              <div className="events-container" style={{ width: "100%" }}>
                {loading ? (
                  <h3 style={{ textAlign: "center" }}>
                    <i className="pi pi-spin pi-spinner-dotted" style={{ fontSize: "2rem", color: "#0cc0df" }}></i>
                  </h3>
                ) : events.past.length > 0 ? (
                  <div className="events-list">
                    {Object.keys(groupedPastEvents)
                      .sort((a, b) => new Date(b) - new Date(a))
                      .map((monthYear, index) => (
                        <div key={index}>
                          <div className="event-header">
                            <span className="event-date">
                              <h3>{monthYear}</h3>
                            </span>
                          </div>
                          {groupedPastEvents[monthYear]
                            .sort((a, b) => (a.id > b.id ? -1 : 1))
                            .map((event, idx) => (
                              <EventTemplate key={idx} {...event} />
                            ))}
                        </div>
                      ))}
                  </div>
                ) : (
                  <h3 style={{ textAlign: "center" }}>No Past Events found.</h3>
                )}
              </div>
            </TabPanel>

            <TabPanel style={{ width: "100%", color: "black" }} header={cancelEventCount()}>
              <div className="events-container" style={{ width: "100%" }}>
                {loading ? (
                  <h3 style={{ textAlign: "center" }}>
                    <i className="pi pi-spin pi-spinner-dotted" style={{ fontSize: "2rem", color: "#0cc0df" }}></i>
                  </h3>
                ) : events.cancel.length > 0 ? (
                  <div className="events-list">
                    {Object.keys(groupedCancelEvents)
                      .sort((a, b) => new Date(b) - new Date(a))
                      .map((monthYear, index) => (
                        <div key={index}>
                          <div className="event-header">
                            <span className="event-date">
                              <h3>{monthYear}</h3>
                            </span>
                          </div>
                          {groupedCancelEvents[monthYear]
                            .sort((a, b) => (a.id > b.id ? -1 : 1))
                            .map((event, idx) => (
                              <EventTemplate key={idx} {...event} />
                            ))}
                        </div>
                      ))}
                  </div>
                ) : (
                  <h3 style={{ textAlign: "center" }}>No Cancelled Events found.</h3>
                )}
              </div>
            </TabPanel>
          </TabView>
        </div>

        {/* Single CreateUpdateEventDialog instance */}
        <CreateUpdateEventDialog
          isVisible={dialogVisible}
          onClose={handleCloseDialog}
          eventDetails={selectedEvent}
          isUpdate={isUpdate}
          onSubmit={handleSubmitEvent}
        />

        <div className="display-containerbox_right">
          <ThurentEventForm
            refreshEvents={fetchEvents}
            openUpdateEventDialog={openUpdateEventDialog}
          />
        </div>
      </div>

      <ConfirmDialog
        visible={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
        message="Do you want to cancel this event?"
        header="Cancel Confirmation"
        icon="pi pi-exclamation-triangle"
        acceptClassName="p-button-danger"
        accept={async () => {
          if (eventIdToDelete) {
            await deleteEventHandle(eventIdToDelete);
            setShowDeleteDialog(false);
            setEventIdToDelete(null);
          }
        }}
        reject={() => {
          setShowDeleteDialog(false);
          setEventIdToDelete(null);
        }}
      />

      <ShowDialogForPayment
        refundItems={refundItems}
        showDialog={showDialog}
        setShowDialog={(val) => {
          setShowDialog(val);
          if (!val) {
            fetchEvents();
          }
        }}
      />
    </div>
  );
};

export default EventTabs;